import { Theme } from './types'

export const THEMES: Theme[] = [
  {
    id: 'cosmos',
    name: 'Cosmos (Default)',
    colors: {
      bgMain: '#020617',
      bgCard: '#0f172a',
      bgElement: '#1e293b',
      bgHover: '#334155',
      border: '#1e293b',
      textMain: '#f8fafc',
      textMuted: '#94a3b8',
      primary: '#6366f1',
    },
  },
  {
    id: 'midnight',
    name: 'Midnight',
    colors: {
      bgMain: '#0B1120',
      bgCard: '#151E32',
      bgElement: '#2A3655',
      bgHover: '#3B4B70',
      border: '#2A3655',
      textMain: '#E2E8F0',
      textMuted: '#94A3B8',
      primary: '#38BDF8',
    },
  },
  {
    id: 'forest',
    name: 'Forest',
    colors: {
      bgMain: '#022C22',
      bgCard: '#064E3B',
      bgElement: '#065F46',
      bgHover: '#047857',
      border: '#065F46',
      textMain: '#ECFDF5',
      textMuted: '#6EE7B7',
      primary: '#10B981',
    },
  },
  {
    id: 'volcano',
    name: 'Volcano',
    colors: {
      bgMain: '#2A0A0A',
      bgCard: '#450A0A',
      bgElement: '#7F1D1D',
      bgHover: '#991B1B',
      border: '#7F1D1D',
      textMain: '#FEF2F2',
      textMuted: '#FCA5A5',
      primary: '#F87171',
    },
  },
  {
    id: 'amethyst',
    name: 'Amethyst',
    colors: {
      bgMain: '#1e0538',
      bgCard: '#2e1065',
      bgElement: '#4c1d95',
      bgHover: '#5b21b6',
      border: '#4c1d95',
      textMain: '#faf5ff',
      textMuted: '#d8b4fe',
      primary: '#a78bfa',
    },
  },
  {
    id: 'ocean',
    name: 'Ocean',
    colors: {
      bgMain: '#083344',
      bgCard: '#164e63',
      bgElement: '#155e75',
      bgHover: '#0e7490',
      border: '#155e75',
      textMain: '#ecfeff',
      textMuted: '#67e8f9',
      primary: '#22d3ee',
    },
  },
  {
    id: 'sunset',
    name: 'Sunset',
    colors: {
      bgMain: '#270a02',
      bgCard: '#431407',
      bgElement: '#7c2d12',
      bgHover: '#9a3412',
      border: '#7c2d12',
      textMain: '#fff7ed',
      textMuted: '#fdba74',
      primary: '#fb923c',
    },
  },
  {
    id: 'monochrome',
    name: 'Monochrome',
    colors: {
      bgMain: '#09090b',
      bgCard: '#18181b',
      bgElement: '#27272a',
      bgHover: '#3f3f46',
      border: '#27272a',
      textMain: '#fafafa',
      textMuted: '#a1a1aa',
      primary: '#ffffff',
    },
  },
  {
    id: 'cyber',
    name: 'Cyber',
    colors: {
      bgMain: '#050505',
      bgCard: '#111',
      bgElement: '#222',
      bgHover: '#333',
      border: '#333',
      textMain: '#e5e5e5',
      textMuted: '#a3a3a3',
      primary: '#00ff41',
    },
  },
  {
    id: 'luxury',
    name: 'Luxury',
    colors: {
      bgMain: '#0c0a09',
      bgCard: '#1c1917',
      bgElement: '#292524',
      bgHover: '#44403c',
      border: '#292524',
      textMain: '#fffbeb',
      textMuted: '#d6d3d1',
      primary: '#fbbf24',
    },
  },
  // High-contrast grayscale themes with accent colors
  {
    id: 'slate',
    name: 'Slate',
    colors: {
      bgMain: '#0a0a0a',
      bgCard: '#171717',
      bgElement: '#262626',
      bgHover: '#404040',
      border: '#262626',
      textMain: '#f5f5f5',
      textMuted: '#a3a3a3',
      primary: '#facc15',
    },
  },
  {
    id: 'graphite',
    name: 'Graphite',
    colors: {
      bgMain: '#0f0f0f',
      bgCard: '#1a1a1a',
      bgElement: '#2a2a2a',
      bgHover: '#3a3a3a',
      border: '#333333',
      textMain: '#e5e5e5',
      textMuted: '#8b8b8b',
      primary: '#14b8a6',
    },
  },
  {
    id: 'obsidian',
    name: 'Obsidian',
    colors: {
      bgMain: '#09090b',
      bgCard: '#18181b',
      bgElement: '#27272a',
      bgHover: '#3f3f46',
      border: '#27272a',
      textMain: '#fafafa',
      textMuted: '#a1a1aa',
      primary: '#f43f5e',
    },
  },
]

export const DEFAULT_THEME = THEMES[0]

export function getThemeById(id: string): Theme {
  return THEMES.find((t) => t.id === id) || DEFAULT_THEME
}
